import { render } from "./BuilderStepDesktopNavigation.vue?vue&type=template&id=a32a1476&scoped=true&ts=true&lang=pug"
import script from "./BuilderStepDesktopNavigation.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuilderStepDesktopNavigation.vue?vue&type=script&lang=ts&setup=true"

import "./BuilderStepDesktopNavigation.vue?vue&type=style&index=0&id=a32a1476&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a32a1476"]])

export default __exports__